import {css} from '../theme/css'

export const overlay = css`
  background-color: rgba(255, 255, 255, 80%);
  height: 100vh;
  inset-block: 0;
  position: fixed;
  width: 100vw;
`
